import React from 'react';

export default function SuggestedReplies({ replies = [], onPick, disabled }) {
  if (!replies.length) return null;
  return (
    <div role="group" aria-label="Suggested replies" className="flex flex-wrap gap-2">
      {replies.map((reply) => (
        <button
          key={reply}
          type="button"
          disabled={disabled}
          onClick={() => onPick(reply)}
          className="min-h-10 px-[15px] rounded-full border border-border bg-background text-foreground text-[13px] leading-[1.2] cursor-pointer hover:bg-muted disabled:cursor-default disabled:opacity-60"
        >
          {reply}
        </button>
      ))}
    </div>
  );
}
